if (window.tailwind) {
    window.tailwind.config = {
    theme: {
      extend: {
         "colors": {
             "surface-bright": "#fbf9f8",
             "on-secondary-fixed-variant": "#6a3b13",
             "inverse-on-surface": "#f2f0f0",
             "tertiary-fixed": "#e5e2df",
             "on-tertiary-fixed": "#1c1c1a",
             "secondary": "#865229", // Cognac
             "surface-container-highest": "#e4e2e2",
             "outline-variant": "#c4c6cf",
             "error": "#ba1a1a",
             "secondary-fixed-dim": "#fcb886",
             "surface-tint": "#495f82",
             "on-tertiary": "#ffffff",
             "background": "#fbf9f8", // Parchment/Off-white
             "tertiary-container": "#1c1c1a",
             "on-primary-fixed": "#011c3b",
             "primary": "#011c3b", // Navy Blue
             "surface-container-low": "#f5f3f3",
             "outline": "#74777f",
             "on-tertiary-container": "#858481",
             "inverse-primary": "#b1c8ef",
             "primary-fixed-dim": "#b1c8ef",
             "on-error-container": "#93000a",
             "surface-dim": "#dbd9d9",
             "on-primary-container": "#6f85a9",
             "secondary-container": "#fcb886",
             "on-secondary-container": "#78461e",
             "error-container": "#ffdad6",
             "tertiary-fixed-dim": "#c8c6c3",
             "on-primary": "#ffffff",
             "on-secondary-fixed": "#301400",
             "surface": "#fbf9f8",
             "on-background": "#1b1c1c",
             "surface-container-lowest": "#ffffff",
             "on-surface-variant": "#44474e",
             "tertiary": "#000000",
             "on-tertiary-fixed-variant": "#474745",
             "on-error": "#ffffff",
             "on-secondary": "#ffffff",
             "surface-variant": "#e4e2e2",
             "on-primary-fixed-variant": "#314768",
             "primary-container": "#011c3b", // Navy Blue
             "surface-container": "#efeded",
             "inverse-surface": "#303030",
             "on-surface": "#1b1c1c",
             "secondary-fixed": "#ffdcc5",
             "surface-container-high": "#eae8e7",
             "primary-fixed": "#d5e3ff",
             "parchment": "#fbf9f8",
             "charcoal": "#44474e"
         },
         "borderRadius": {
             "DEFAULT": "0.125rem",
             "lg": "0.25rem",
             "xl": "0.5rem",
             "full": "0.75rem"
         },
         "spacing": {
             "margin-edge": "40px",
             "container-max": "1280px",
             "stack-md": "16px",
             "gutter": "24px",
             "stack-lg": "32px",
             "stack-sm": "8px",
             "section-gap": "120px"
         },
         "fontSize": {
             "label-caps": ["12px", {"lineHeight": "16px", "letterSpacing": "0.1em", "fontWeight": "600"}],
             "price-lg": ["20px", {"lineHeight": "24px", "fontWeight": "500"}],
             "display-lg": ["64px", {"lineHeight": "72px", "letterSpacing": "-0.02em", "fontWeight": "500"}],
             "display-xl": ["80px", {"lineHeight": "88px", "letterSpacing": "-0.02em", "fontWeight": "500"}],
             "headline-lg": ["40px", {"lineHeight": "48px", "fontWeight": "500"}],
             "headline-lg-mobile": ["32px", {"lineHeight": "38px", "fontWeight": "500"}],
             "body-md": ["16px", {"lineHeight": "24px", "fontWeight": "400"}],
             "body-lg": ["18px", {"lineHeight": "28px", "fontWeight": "400"}]
         }
       },
    },
 };
}